import { c as _c } from "react/compiler-runtime";
import type { HometownNewsApiDto } from '__generated__/api/unauth/types.gen';
import { Fragment } from 'react';
import { SearchCategoryAdSlot } from '@/app/_components/ads';
import { ROUTES } from '@/constants';
import { buildDetailSlug } from '@/utils/detailSlug';
import { PREVIEW_SIZE } from '../../constants';
import { formatDateLabel } from '../../utils';
import { SearchContentsCard } from '../SearchContentsCard';
import { SearchContentsCardSkeletonList } from '../SearchContentsCardSkeleton';
import { SectionHeader } from './SectionHeader';
export function HometownNewsPreviewSection(t0) {
  const $ = _c(11);
  const {
    keyword,
    items,
    totalCount,
    isLoading
  } = t0;
  if (!isLoading && items.length < 1) {
    return null;
  }
  let t1;
  if ($[0] !== keyword) {
    t1 = ROUTES.SEARCH.withSearchParams({
      searchParams: {
        q: keyword || undefined,
        category: "hometown-news"
      }
    });
    $[0] = keyword;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1 || $[3] !== totalCount) {
    t2 = <SectionHeader title={"\uB3D9\uB124\uC18C\uC2DD"} totalCount={totalCount} moreHref={t1} />;
    $[2] = t1;
    $[3] = totalCount;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isLoading || $[6] !== items) {
    t3 = isLoading ? <SearchContentsCardSkeletonList count={PREVIEW_SIZE} /> : <ul className="flex flex-col gap-12 mobile-tablet:gap-0 mobile-tablet:divide-y mobile-tablet:divide-Gray-100">{items.map((item, index) => <Fragment key={item.hometownNewsIdIdx ?? item.hometownNewsId}><SearchCategoryAdSlot as="li" placement="search-all-hometowns" position={index + 1} listLength={items.length} /><li><SearchContentsCard imageSrc={item.thumbnail} title={item.hometownNewsName} content={item.summary} daysAgo={formatDateLabel(item.publishedAt) || item.daysAgo} link={ROUTES.HOMETOWN_NEWS_DETAIL.pathname({
            idIdx: item.slugId ?? buildDetailSlug(item.hometownNewsIdIdx ?? "", item.hometownNewsName)
          })} /></li></Fragment>)}</ul>;
    $[5] = isLoading;
    $[6] = items;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <section className="flex w-full flex-col">{t2}{t3}</section>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}